module.exports = __webpack_public_path__ + "img/The Premiere.fa234535.png";